import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
export interface navType {
  label: string;
  imageUrl?: string;
  activeImageUrl?: string;
  webRoute: string;
  // subNav?: navType[];   // may be added later
}

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  constructor(private router: Router) { }

  public getAllPermissions(): any {
    return JSON.parse(localStorage.getItem('permissons') ?? '{}');
  }

  public getSideNavigation(themeStyles: any): any {
    const perms = this.getAllPermissions();
    const navBarTabs: any = this.getSubView(perms, themeStyles);
    return navBarTabs;
  }

  // may need to implement recursive func for sub views if required
  private getSubView(view: any, themeStyles: any): any {
    const sideNavTabs: navType[] = [];
    const keys = Object.keys(view);
    for (let i = 0; i < keys.length; i++) {
      const item = keys[i];
      if (view[item].viewType === 'C') {
        sideNavTabs.push({
          label: view[item].viewLabel,
          // imageUrl: themeStyles.getPropertyValue(`--${view[item].icon}`),
          // activeImageUrl: themeStyles.getPropertyValue(
          // `${view[item].iconActive}`
          // ),
          webRoute: view[item].webRoute,
        });
      }
    }

    return sideNavTabs;
  }

  public getLandingRoute() {
    const firstSubView: any = Object.values(this.getAllPermissions())[0];
    let landingRoute = '';
    landingRoute += firstSubView.webRoute;

    let subView: any[] = [];
    Object.entries(firstSubView as Object).forEach(([key, child]) => {
      if (child?.default) {
        subView.push(child);
      }
    });

    // if (subView.length > 0) landingRoute += `/${subView[0].webRoute}`;
    return landingRoute;
  }

  public getPermByViewName() {
    const currentUrl = this.router.url;
    const fullUrl = currentUrl.split('?')[0].split('/').filter(Boolean);
    const perms: Record<string, any> = this.getAllPermissions();
    const lastRoute = fullUrl[fullUrl.length - 1];
    const matchedRoute = Object.values(perms).find(
      (item: any) => item.webRoute === lastRoute
    );
    return matchedRoute ? matchedRoute['default'].permission : null;
  }
  public getAllPermArrByViewName(perm: any) {
    const all = this.getAllPermArr(perm);
    return Array.from(new Set(all));
  }
  getAllPermArr(permission: any): any {
    let perms = [];

    if (Array.isArray(permission)) {
      perms.push(...permission);
    } else if (permission && typeof permission === 'object') {
      for (const key of Object.keys(permission)) {
        perms.push(...this.getAllPermArr(permission[key]));
      }
    }
    return perms;
  }

  public getSubViewByViewName(fullUrl: string[]) {
    // const currentUrl = this.router.url;
    // const fullUrl = currentUrl.split('?')[0].split('/').filter(Boolean);
    const perms: Record<string, any> = this.getAllPermissions();
    const matchedRoute = this.matchRoute(perms, fullUrl, 0);

    let subView: any[] = [];
    Object.entries(matchedRoute as Object).forEach(([key, child]) => {
      if (child?.default) {
        subView.push(child);
      }
    });
    return subView;
  }

  private matchRoute(
    obj: Record<string, any>,
    parts: string[],
    index: number
  ): Record<string, any> | null {
    if (index >= parts.length) return obj;
    const matchedEntry = Object.entries(obj).find(
      ([, child]) => child?.webRoute === parts[index]
    );

    return matchedEntry
      ? this.matchRoute(matchedEntry[1], parts, index + 1)
      : null;
  }
}
